import React from 'react';
import { motion } from 'framer-motion';

const head_faculties = [
  {
    id: 5,
    name: 'Brahmanandan K',
    desgination: 'Administrator',
    imageSrc: '/assets/images/faculties/Brahmanandan K.jpg',
    imageAlt: '',
  },
  {
    id: 12,
    name: 'Bideno Tsopoe',
    desgination: 'Headmistress',
    imageSrc: '/assets/images/faculties/Bideno Tsopoe.jpg',
    imageAlt: ""
  },
]
const faculties = [
  
  {
    id: 6,
    name: 'Pumang Amos',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Pumang Amos.jpg',
    imageAlt: '',
  },
  {
    id: 1,
    name: 'Ramayan Prasad Yadav',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/ramayan_prasad_yadav.jpg',
    imageAlt: '',
  },
  {
    id: 3,
    name: 'Sonu Kumar Mishra',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Sonu Kumar Mishra.jpg',
    imageAlt: '',
  },
  {
    id: 17,
    name: 'Kekhrieu Tsukru',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Kekhrieu Tsukru.jpg',
    imageAlt: '',
  },
  {
    id: 13,
    name: 'Vizoto',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Vizoto.jpg',
    imageAlt: '',
  },
  {
    id: 18,
    name: 'Mhasizolie Angami',
    desgination: 'Office Asst.',
    imageSrc: '/assets/images/faculties/Mhasizolie Angami.jpg',
    imageAlt: '',
  },
  {
    id: 14,
    name: 'Akokla Ozukum',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Akokla Ozukum.jpg', // kjdhlahf
    imageAlt: '',
  },
  {
    id: 19,
    name: 'Neibu Ratsa',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Neibu Ratsa.jpg',
    imageAlt: '',
  },
  {
    id: 8,
    name: 'Sulika Assumi',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Sulika Assumi.jpg',//bububyb
    imageAlt: '',
  },
  {
    id: 4,
    name: 'Mhalo Tungoe',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Mhalo Tungoe.jpg',
    imageAlt: '',
  },
  {
    id: 7,
    name: 'Atso O Koza',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Atso O Koza.jpg',///huyh
    imageAlt: '',
  },

  {
    id: 9,
    name: 'N Esther',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/N Esther.jpg',//huiuhi
    imageAlt: '',
  },
  {
    id: 10,
    name: 'Mechieteü Lomi',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Mechieteü Lomi.jpg',//uuh
    imageAlt: '',
  },
  {
    id: 16,
    name: 'Sedevino Tsukru',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Sedevino Tsukru.jpg',//ytguygyu
    imageAlt: '',
  },
  {
    id: 18,
    name: 'Kilitoli Zhimo',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Kilitoli Zhimo.jpg',
    imageAlt: '',
  },
  {
    id: 17,
    name: 'Kevisetouno Nakhro',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Kevisetouno Nakhro.jpg',
    imageAlt: '',
  },
  {
    id: 19,
    name: 'Mughakali P Assumi',
    desgination: 'Asst. Teacher',
    imageSrc: '/assets/images/faculties/Mughakali P Assumi.jpg',
    imageAlt: '',
  },

  

]


const Faculty = () => (

  <div className="mx-auto text-center bg-gray-300 px-4 py-10 sm:px-6 sm:py-24 lg:px-8">
    <h2 className="text-3xl font-bold mb-8 text-theme" style={{textShadow: "1px 1px 1px rgba(0, 0, 0, 0.5)"}}>Our Faculties</h2>
    <h2 className="sr-only">Our Faculties</h2>

    <div className="m-auto max-w-fit mb-12 grid grid-cols-1 justify-items-center gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
      {head_faculties.map((faculty, idx) => (
        <motion.article
          key={idx}
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ ease: 'easeOut' }}
          viewport={{ once: false }}
          className={`bg-white shadow-lg rounded-lg pb-4 group relative pb-4 mb-4`}>
          <img
            alt={faculty.imageAlt}
            src={faculty.imageSrc ||  "https://www.strasys.uk/wp-content/uploads/2022/02/Depositphotos_484354208_S.jpg"}
            className="aspect-[3/4] w-72 rounded-lg bg-gray-200 object-cover group-hover:opacity-75 xl:aspect-[7/8]"
          />
          <h3 className="mt-4 text-lg text-gray-700">{faculty.name}</h3>
          <p className="mt-1 text-sm font-medium text-gray-900">{faculty.desgination}</p>
        </motion.article>
      ))}
    </div>
    <div className="grid grid-cols-1 justify-items-center gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">
      {faculties.map((faculty, idx) => (
        <motion.article
          key={idx}
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ ease: 'easeOut' }}
          viewport={{ once: false }}
          className={`bg-white shadow-lg rounded-lg pb-4 group relative pb-4 mb-4`}>

            <img
              alt={faculty.imageAlt}
              src={faculty.imageSrc ||  "https://www.strasys.uk/wp-content/uploads/2022/02/Depositphotos_484354208_S.jpg"}
              className="aspect-[3/4] w-72 rounded-lg bg-gray-200 object-cover group-hover:opacity-75 xl:aspect-[7/8]"
            />
            <h3 className="mt-4 text-lg text-gray-700">{faculty.name}</h3>
            <p className="mt-1 text-sm font-medium text-gray-900">{faculty.desgination}</p>
        </motion.article>
      ))}
    </div>
  </div>
);

export default Faculty;